import React, { useState, useEffect } from 'react';
import { Drawer } from 'antd';

const CustomDrawer = ({ children, width = 600, ...props }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <Drawer
      placement={isMobile ? 'bottom' : 'right'}
      width={isMobile ? '100%' : width}
      height={isMobile ? '80vh' : '100%'}
      style={{
        borderTopLeftRadius: isMobile ? 16 : 0,
        borderTopRightRadius: isMobile ? 16 : 0,
      }}
      {...props}
    >
      {children}
    </Drawer>
  );
};

export default CustomDrawer;
